import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submenu", "icon"]
  static values = { expanded: Boolean }

  connect() {
    
    // Set initial state based on expanded value
    if (this.expandedValue) {
      this.show()
    } else {
      this.hide()
    }
  }

  toggle() {
    if (this.isExpanded()) {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    if (this.hasSubmenuTarget) {
      this.submenuTarget.classList.remove("hidden")
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.add("rotate-180")
    }
  }

  hide() {
    if (this.hasSubmenuTarget) {
      this.submenuTarget.classList.add("hidden")
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-180")
    }
  }

  isExpanded() {
    return this.hasSubmenuTarget && !this.submenuTarget.classList.contains("hidden")
  }
}
